import React from "react";
import { TouchableOpacity, View } from "react-native";

import { ThemedText } from "@/components/ThemedText";

export type SegmentedControlOption<T extends string> = {
  value: T;
  label: string;
};

type Props<T extends string> = {
  options: SegmentedControlOption<T>[];
  value: T;
  onChange: (value: T) => void;
  testID?: string;
};

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  testID,
}: Props<T>) {
  return (
    <View className="w-full flex-row rounded-xl bg-gray-100 p-1" testID={testID}>
      {options.map((option) => {
        const active = option.value === value;
        return (
          <TouchableOpacity
            key={option.value}
            accessibilityRole="tab"
            accessibilityState={{ selected: active }}
            testID={testID ? `${testID}-${option.value}` : undefined}
            onPress={() => onChange(option.value)}
            className={`flex-1 items-center justify-center rounded-lg py-2 ${
              active ? "bg-white shadow" : "bg-transparent"
            }`}
          >
            <ThemedText
              className={`text-sm font-medium ${
                active ? "text-gray-900" : "text-gray-500"
              }`}
            >
              {option.label}
            </ThemedText>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

export default SegmentedControl;
